import React, { useMemo } from "react";
import { format, fromUnixTime, addHours } from "date-fns";
import { toZonedTime } from "date-fns-tz";

function groupConsecutiveTimestamps(timestamps) {
  timestamps.sort((a, b) => a - b);

  const groups = [];
  let currentGroup = [];

  for (let i = 0; i < timestamps.length; i++) {
    if (
      currentGroup.length === 0 ||
      timestamps[i] - currentGroup[currentGroup.length - 1] === 3600
    ) {
      currentGroup.push(timestamps[i]);
    } else {
      if (currentGroup.length > 0) {
        groups.push([
          currentGroup[0],
          currentGroup[currentGroup.length - 1] + 3600,
        ]);
      }
      currentGroup = [timestamps[i]];
    }
  }
  if (currentGroup.length > 0) {
    groups.push([
      currentGroup[0],
      currentGroup[currentGroup.length - 1] + 3600,
    ]);
  }

  return groups;
}

export default function SelectedSlots({ availability, timezone }) {
  const groupedSlots = useMemo(
    () => groupConsecutiveTimestamps(availability),
    [availability]
  );

  const formatDate = (timestamp) => {
    const date = toZonedTime(fromUnixTime(timestamp), timezone);
    return format(date, "EEE, MMM d, HH:mm");
  };

  return (
    <div className="mt-4 p-4 bg-gray-100 rounded-lg overflow-auto">
      <h3 className="text-lg font-semibold mb-2">Selected Time Slots:</h3>
      {groupedSlots.length > 0 ? (
        <ul className="space-y-2">
          {groupedSlots.map(([start, end], index) => {
            const startDate = formatDate(start);
            const endDate = formatDate(end);
            return (
              <li key={index} className="bg-white p-2 rounded shadow">
                <span className="font-medium">{startDate}</span> to:{" "}
                <span className="font-medium">{endDate}</span> ({timezone})
              </li>
            );
          })}
        </ul>
      ) : (
        <p>No time slots selected.</p>
      )}
    </div>
  );
}
